export default class NumberUtils {
	public static stringToIntWithFactor(value: string, factor: number): number {
		const num = parseFloat(value);
		return parseInt((num * factor).toString())
	}
}